/**
 * @generated SignedSource<<6bda8c57efd9433a308183b1d89b141f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLocationItems_viewer$data = {
  readonly locationItemsInfo?: ReadonlyArray<{
    readonly locationPage: {
      readonly displayName: string | null;
      readonly items: ReadonlyArray<{
        readonly browseUrl: string | null;
        readonly categoryCode: string | null;
        readonly contemporaryTrackingString: string;
        readonly firstPhotoWebPath: string | null;
        readonly linkData: {
          readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
        };
        readonly seller: {
          readonly serviceId: string | null;
        } | null;
        readonly serviceId: string | null;
        readonly title: string | null;
      } | null> | null;
      readonly linkData: {
        readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
      };
    } | null;
  } | null> | null;
  readonly " $fragmentType": "HpSharedLocationItems_viewer";
};
export type HpSharedLocationItems_viewer$key = {
  readonly " $data"?: HpSharedLocationItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationItems_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData"
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "locationItemsCount"
    },
    {
      "kind": "RootArgument",
      "name": "zipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLocationItems_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "locationItemsInfo",
          "args": [
            {
              "kind": "Literal",
              "name": "regionTypes",
              "value": "ITEM_LOCATION"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "zipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "maxWeight",
                  "value": "METROPOLITAN"
                },
                {
                  "kind": "Literal",
                  "name": "minCount",
                  "value": 1
                },
                {
                  "kind": "Literal",
                  "name": "minWeight",
                  "value": "DISTRICT"
                },
                {
                  "kind": "Literal",
                  "name": "usOnly",
                  "value": true
                }
              ],
              "concreteType": "LocationPage",
              "kind": "LinkedField",
              "name": "locationPage",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "count",
                      "variableName": "locationItemsCount"
                    }
                  ],
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "browseUrl",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "categoryCode",
                      "storageKey": null
                    },
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contemporaryTrackingString",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "size",
                          "value": "master"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "firstPhotoWebPath",
                      "storageKey": "firstPhotoWebPath(size:\"master\")"
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Seller",
                      "kind": "LinkedField",
                      "name": "seller",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "locationPage(maxWeight:\"METROPOLITAN\",minCount:1,minWeight:\"DISTRICT\",usOnly:true)"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "c61d44f2795d6253b4e88945038d03a3";

export default node;
